import { CoApplicantFields } from '@common/entities';

export interface CoapplicantCompatibilityItem {
  age_over_17?: string;
  coapplicant_age_over_17: string;
  coapplicant_first_name: string;
  first_name?: string;
  coapplicant_middle_name: string;
  middle_name?: string;
  coapplicant_last_name: string;
  last_name?: string;
  coapplicant_email: string;
  email?: string;
  coapplicant_phone_number: string;
  phone_number?: string;
  coapplicant_date_of_birth: string;
  date_of_birth?: string;
  relationship?: string | number;
  responseId?: string;
  uid?: string;
  applicantId?: number | null;
  customerId?: number | null;
}

const LEGACY_COAPPLICANT_FIELD_NAME_MAP: Record<string, string> = {
  age_over_17: CoApplicantFields.ageOver17.name,
  first_name: CoApplicantFields.firstName.name,
  middle_name: CoApplicantFields.middleName.name,
  last_name: CoApplicantFields.lastName.name,
  email: CoApplicantFields.email.name,
  phone_number: CoApplicantFields.phoneNumber.name,
  date_of_birth: CoApplicantFields.dateOfBirth.name,
  relationship_to_applicant: CoApplicantFields.relationship.name,
};

export function normalizeCoApplicantFieldName(name: string): string {
  return LEGACY_COAPPLICANT_FIELD_NAME_MAP[name] ?? name;
}

export function normalizeCoapplicantListItem(
  item: CoapplicantCompatibilityItem,
): CoapplicantCompatibilityItem {
  return {
    ...item,
    coapplicant_age_over_17: item.coapplicant_age_over_17 ?? item.age_over_17 ?? '',
    coapplicant_first_name: item.coapplicant_first_name ?? item.first_name ?? '',
    coapplicant_middle_name: item.coapplicant_middle_name ?? item.middle_name ?? '',
    coapplicant_last_name: item.coapplicant_last_name ?? item.last_name ?? '',
    coapplicant_email: item.coapplicant_email ?? item.email ?? '',
    coapplicant_phone_number: item.coapplicant_phone_number ?? item.phone_number ?? '',
    coapplicant_date_of_birth: item.coapplicant_date_of_birth ?? item.date_of_birth ?? '',
  };
}

export function normalizeCoapplicantList(
  list: CoapplicantCompatibilityItem[] | null | undefined,
): CoapplicantCompatibilityItem[] {
  if (!Array.isArray(list)) {
    return [];
  }

  return list.map((item) => normalizeCoapplicantListItem(item));
}
